import outputs from 'root/cfOutput';
import { isLocalEnv, isLocalhost } from 'root/src/shared/util/envSelect';
export function getDareDropApiUrl() {
    if (isLocalEnv || isLocalhost) {
        return 'http://localhost:9899/v1';
    }
    return `https://api.${outputs.domainName}/v1`;
}
